import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

interface DocumentMetaData {
  fileName: string;
  snapId: string;
}

const fetchDocumentMetaData = (
  clientId: string,
  draftId: string,
  snapId?: string,
): Promise<DocumentMetaData> => {
  return authFetch(
    urlWithParams('/Consumer/ManagedAccounts/GetDocumentMetadata', {
      clientId,
      id: draftId,
      snapId,
    }),
  );
};

interface DocumentMetaDataQueryParams {
  clientId: string;
  draftId: string;
  snapId?: string;
  isAffiliatedExchangeOrFINRA?: boolean;
}

export const useDocumentMetaDataQuery = ({
  clientId,
  draftId,
  snapId,
  isAffiliatedExchangeOrFINRA,
}: DocumentMetaDataQueryParams) => {
  return useQuery(
    queryKeys.documentMetadata(clientId, draftId, snapId),

    () => fetchDocumentMetaData(clientId, draftId, snapId),

    {
      enabled: !!snapId && !!isAffiliatedExchangeOrFINRA,
    },
  );
};
